import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const auth = {
  session: (session_id) => api.post("/auth/session", { session_id }).then((r) => r.data),
  me: () => api.get("/auth/me").then((r) => r.data),
  logout: () => api.post("/auth/logout").then((r) => r.data),
};

export const profile = {
  update: (data) => api.patch("/profile", data).then((r) => r.data),
};

export const plans = {
  list: () => api.get("/plans").then((r) => r.data),
};

export const payments = {
  createOrder: (plan_id) =>
    api.post("/payments/create-order", { plan_id }).then((r) => r.data),
  getOrder: (order_id) =>
    api.get(`/payments/order/${order_id}`).then((r) => r.data),
};

export const playlist = {
  get: () => api.get("/playlist").then((r) => r.data),
  add: (url_or_id) => api.post("/playlist/songs", { url_or_id }).then((r) => r.data),
  remove: (song_uid) => api.delete(`/playlist/songs/${song_uid}`).then((r) => r.data),
  updateBpm: (song_uid, bpm) =>
    api.patch(`/playlist/songs/${song_uid}`, { bpm }).then((r) => r.data),
  markDropEnd: (song_uid, drop_end_seconds) =>
    api.patch(`/playlist/songs/${song_uid}`, { drop_end_seconds }).then((r) => r.data),
  reorder: (song_uids) =>
    api.post("/playlist/reorder", { song_uids }).then((r) => r.data),
  search: (q) => api.get("/youtube/search", { params: { q } }).then((r) => r.data),
  import: (playlist_url) =>
    api.post("/playlist/import", { playlist_url }).then((r) => r.data),
};

export const collab = {
  info: (token) => api.get(`/collab/${token}`).then((r) => r.data),
  songs: (token) => api.get(`/collab/${token}/songs`).then((r) => r.data),
  search: (token, q) =>
    api.get(`/collab/${token}/search`, { params: { q } }).then((r) => r.data),
  add: (token, url_or_id, name) =>
    api
      .post("/collab/add", { share_token: token, url_or_id, added_by_name: name })
      .then((r) => r.data),
};

export const sessions = {
  heartbeat: (session_id) =>
    api.post("/sessions/heartbeat", { session_id: session_id || null }).then((r) => r.data),
};

export const admin = {
  login: (username, password) =>
    api.post("/admin/login", { username, password }).then((r) => r.data),
  logout: () => api.post("/admin/logout").then((r) => r.data),
  me: () => api.get("/admin/me").then((r) => r.data),
  stats: () => api.get("/admin/stats").then((r) => r.data),
};
